import React from 'react';
import { Container } from '@mui/material';
import "./spinner.scss";
import { useSelector } from 'react-redux';

const Spinner = () => {
    const { logoutSession } = useSelector((state) => state.authToken);

    return (
        !logoutSession && <div className="spinner-container">
            <Container>
                <div className="spinner"></div>
            </Container>
        </div>
    )
}

export default Spinner